/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import BenefitsGroup from '@components/UI/LandingPages/BenefitsGroup';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 *
 * @param {Object} param0
 * @returns
 */
const BenefitsSection = ({ section, region, lang }) => {
  return (
    <Box pb={'60px'}>
      <BenefitsGroup
        sectionContent={section?.sectionContent[0]}
        section={section}
        region={region}
        lang={lang}
      />
      <Flex placeContent="center">
        <SimpleButton
          style={section?.sectionContent[1]}
          region={region}
          lang={lang}
          mt="9px"
          mb="0"
          fontSize="16px"
          px="44px"
          clickHandler={() => window.dataLayer.push({ event: 'goy_register2' })}
        />
      </Flex>
      <Flex placeContent="center">
        <StructuredTextParser
          str={render(section?.sectionContent[2]?.body)}
          region={region}
          lang={lang}
          tAlign={'center-align'}
          fontSize="16px"
          color="#28231E"
          textDecoration="underline"
          id={section?.sectionContent[2]?.fieldId}
        />
      </Flex>
    </Box>
  );
};

export default BenefitsSection;
